import React from "react";

interface ArrowsIconProps {
 fill?: string;
 onClick?: () => void;
 width?: string;
 height?: string;
}

const Reports: React.FC<ArrowsIconProps> = (props) => {
 return (
   <svg
     width={props.width ?? "24"}
     height={props.height ?? "25"}
     viewBox="0 0 24 25"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     onClick={props.onClick}
   >
     <path
       d="M14 3.05957V7.19011C14 7.75016 14 8.03019 14.109 8.2441C14.2049 8.43226 14.3578 8.58524 14.546 8.68112C14.7599 8.79011 15.0399 8.79011 15.6 8.79011H19.7305M8 15.79V18.79M16 13.79V18.79M12 11.29V18.79M20 10.7783V17.99C20 19.6702 20 20.5103 19.673 21.152C19.3854 21.7165 18.9265 22.1754 18.362 22.4631C17.7202 22.79 16.8802 22.79 15.2 22.79H8.8C7.11984 22.79 6.27976 22.79 5.63803 22.4631C5.07354 22.1754 4.6146 21.7165 4.32698 21.152C4 20.5103 4 19.6702 4 17.99V7.59004C4 5.90988 4 5.0698 4.32698 4.42807C4.6146 3.86358 5.07354 3.40464 5.63803 3.11702C6.27976 2.79004 7.11984 2.79004 8.8 2.79004H12.0118C12.7455 2.79004 13.1124 2.79004 13.4577 2.87293C13.7638 2.94642 14.0564 3.06763 14.3249 3.23212C14.6276 3.41764 14.887 3.67707 15.4059 4.19593L18.5941 7.38415C19.113 7.90301 19.3724 8.16243 19.5579 8.46518C19.7224 8.7336 19.8436 9.02623 19.9171 9.33234C20 9.67761 20 10.0445 20 10.7783Z"
       stroke={props.fill || "white"}
       strokeWidth="1.5"
       strokeLinecap="round"
       strokeLinejoin="round"
     />
   </svg>
 );
};

export default Reports;